export function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./~/.3.0.3@react-router/es/PromiseUtils.js
// module id = 191
// module chunks = 0